import React from "react";
import classNames from "./AuthFormContainer.module.css";

const AuthFormContainer = ({ form }) => {
  return (
    <div className={classNames.container}>
      <div className={classNames.form_container}>
        {/* <div className={classNames.hearts}>
          <span className={`${classNames.heart} ${classNames.heart2}`}></span>
          <span className={classNames.heart}></span>
        </div> */}

        <div className={classNames.form}>{form}</div>
        {/* <div className={classNames.hearts2}>
          <span
            className={`${classNames.heart} ${classNames.heart2}`}
            style={{ left: "95%" }}
          ></span>
          <span className={classNames.heart} style={{ left: "85%" }}></span>
        </div> */}
      </div>
    </div>
  );
};

export default AuthFormContainer;
